import { MutationOptions } from '@tanstack/react-query';
import { downloadFilePrintedQueryFunction } from '@/modules/FileDetail/queries/documentation/downloadZip/downloadFilePrinted/downloadFilePrintedQueryFunction';
import {
  DownloadFilePrintedPicturesQueryResponseType,
  DownloadFilePrintedPicturesZipType,
} from '@/modules/FileDetail/queries/documentation/downloadZip/downloadFilePrinted/downloadFilePrintedQuery.type';

export const downloadFilePrintedQueryOptions = (): MutationOptions<
  DownloadFilePrintedPicturesQueryResponseType,
  Error,
  DownloadFilePrintedPicturesZipType
> => ({
  mutationKey: ['downloadFilePrintedQueryOptions'],
  mutationFn: (params: DownloadFilePrintedPicturesZipType) =>
    downloadFilePrintedQueryFunction({
      id: params.id,
      show_image: params?.show_image,
      images_quality: params?.images_quality,
    }),
});
